// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `fi-widget-number-of-records-to-take .mat-mdc-form-field {
  display: block;
}`, "",{"version":3,"sources":["webpack://./Source/app/widget-settings/number-of-records-to-take/number-of-records-to-take.component.scss"],"names":[],"mappings":"AACI;EACI,cAAA;AAAR","sourcesContent":["fi-widget-number-of-records-to-take {\r\n    .mat-mdc-form-field {\r\n        display: block;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
